import { useQuery } from "@tanstack/react-query";
import type { JSX } from "react";
import { useORPC } from "../../orpc-react.tsx";
import type { TaskDocumentIdentifier } from "../../services/task-documents.ts";
import "./TaskDocumentList.css";

export type TaskDocumentListProps = {
  onSelectTask: (taskId: TaskDocumentIdentifier) => void;
  selectedTaskId?: TaskDocumentIdentifier;
};

export function TaskDocumentList(props: TaskDocumentListProps): JSX.Element {
  const orpc = useORPC();
  const tasks = useQuery(orpc.tasks.list.queryOptions({ input: {} }));

  if (tasks.isLoading) return <p role="status">Loading tasks...</p>;
  if (tasks.isError)
    return (
      <div role="alert">
        <p>{tasks.error.message}</p>
        <button onClick={() => void tasks.refetch()} type="button">
          Retry
        </button>
      </div>
    );
  if (!tasks.data || tasks.data.length === 0) return <p>No task documents.</p>;

  return (
    <nav aria-label="Task documents">
      <ul className="task-document-list">
        {tasks.data.map((task) => (
          <li key={task.id}>
            <button
              aria-current={task.id === props.selectedTaskId ? "page" : undefined}
              onClick={() => props.onSelectTask(task.id)}
              type="button"
            >
              <span className="task-document-list-title">{task.title}</span>
              <span className="task-document-list-id">{task.id}</span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
